<template>
  <div class="pl-3 pr-3">
      <b-row>
          <b-col lg="6" class="border-right py-5"  order-lg="1" order="2">
              <h5 class="mb-4 font-size-14 px-2">Activity INFORMATION</h5>
              <b-row class="pl-3 mb-2">
                  <b-col md="12" class="infoKey">
                      <p>Description</p>
                  </b-col>
                  <b-col md="12" class="infoValue">
                      <p class="text-black font-weight-bold-600">{{activityDetails.description}}</p>
                  </b-col>
              </b-row>
              <b-row class="pl-3 mb-2" v-if="activityDetails.duration">
                  <b-col md="12" class="infoKey">
                      <p>Duration</p>
                  </b-col>
                  <b-col md="12" class="infoValue">
                      <p class="text-black font-weight-bold-600">{{activityDetails.duration}} {{activityDetails.duration_list.name}}</p>
                  </b-col>
              </b-row>
              <b-row class="pl-3 mb-2">
                  <b-col md="12" class="infoKey">
                      <p>Conditions</p>
                  </b-col>
                  <b-col md="12" class="infoValue">
                      <p class="text-black font-weight-bold-600">{{activityDetails.conditions}}</p>
                  </b-col>
              </b-row>
              <b-row class="pl-3 mb-2">
                <b-col md="12" class="infoKey">
                    <p>Requirements</p>
                </b-col>
                <b-col md="12" class="infoValue">
                    <p class="text-black font-weight-bold-600">{{activityDetails.requirements}}</p>
                </b-col>
            </b-row>

            <b-row class="pl-3 mb-3">
                <b-col md="12" class="infoKey">
                    <p>Locations</p>
                </b-col>
                <b-col md="12" v-if="activityDetails.locations.length">
                    <template v-for="(location, key) in activityDetails.locations">
                        <p :key="key" class="text-black font-weight-bold-600">{{ location.name }} : {{ location.link }}</p>
                    </template>
                </b-col>
                <b-col md="12" v-else>
                    <p class="text-black font-weight-bold-600">* Your Facility Location</p>
                </b-col>
            </b-row>

          </b-col>
          <b-col lg="6" class="py-5" order-lg="2" order="1">
              <h5 class="mb-4 font-size-14">Activity PHOTO</h5>
              <slider-thumbs :images="activityDetails.images"/>
          </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
  props: {
    activityDetails: {
      type: Object
    }
  }
}

</script>
<style></style>
